
const options = { timeZone: "Europe/London", hour12: false };

function updateDeliveryCountdown() {
  const now = new Date();
  const ukYear = parseInt(new Intl.DateTimeFormat("en-GB", { ...options, year: "numeric" }).format(now));
  const ukMonth = parseInt(new Intl.DateTimeFormat("en-GB", { ...options, month: "numeric" }).format(now));
  const ukDay = parseInt(new Intl.DateTimeFormat("en-GB", { ...options, day: "numeric" }).format(now));
  const ukHour = parseInt(new Intl.DateTimeFormat("en-GB", { ...options, hour: "2-digit" }).format(now));
  const ukMinute = parseInt(new Intl.DateTimeFormat("en-GB", { ...options, minute: "2-digit" }).format(now));
  const ukSecond = parseInt(new Intl.DateTimeFormat("en-GB", { ...options, second: "2-digit" }).format(now));
  const ukNow = new Date(ukYear, ukMonth - 1, ukDay, ukHour, ukMinute, ukSecond);
  let cutoff = new Date(ukYear, ukMonth - 1, ukDay, 17, 0, 0);
  let weekday = ukNow.getDay();
  if (weekday === 6) {
    cutoff.setDate(cutoff.getDate() + 2);
  } else if (weekday === 0) {
    cutoff.setDate(cutoff.getDate() + 1);
  } else if (ukNow >= cutoff) {
    cutoff.setDate(cutoff.getDate() + 1);
    if (cutoff.getDay() === 6) {
      cutoff.setDate(cutoff.getDate() + 2); 
    }
    if (cutoff.getDay() === 0) {
      cutoff.setDate(cutoff.getDate() + 1); 
    }
  }
  let diff = cutoff - ukNow;
  let displayTime;

  if (diff > 0) {
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    const format = (n) => (n < 10 ? "0" + n : n);
    displayTime = `${format(hours)}:${format(minutes)}:${format(seconds)}`;
  } else {
    displayTime = "00:00:00";
  }

  document.querySelectorAll(".js-delivery-target").forEach((el) => {
    el.textContent = displayTime;
  });
}
function updateNextDayName() {
  const now = new Date();
  const ukNow = new Date(
    new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    })
      .format(now)
      .replace(
        /(\d+)\/(\d+)\/(\d+),\s*(\d+):(\d+):(\d+)/,
        (m, d, mth, y, h, min, s) =>
          `${y}-${mth}-${d}T${h.padStart(2, "0")}:${min.padStart(
            2,
            "0"
          )}:${s.padStart(2, "0")}`
      )
  );

  const weekday = ukNow.getDay(); 
  const cutoff = new Date(ukNow);
  cutoff.setHours(17, 0, 0, 0);

  let deliveryDate = new Date(ukNow);

  if (weekday >= 1 && weekday <= 4) {
    if (ukNow < cutoff) {
      deliveryDate.setDate(deliveryDate.getDate() + 1); 
    } else {
      deliveryDate.setDate(deliveryDate.getDate() + 2); 
    }
 } else if (weekday === 5) {
  if (ukNow < cutoff) {
    deliveryDate.setDate(deliveryDate.getDate() + 1); 
  } else {
    deliveryDate.setDate(deliveryDate.getDate() + 4); 
  }
}
 else if (weekday === 6) {
    deliveryDate.setDate(deliveryDate.getDate() + 3);
  } else if (weekday === 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 2); 
  }

  const nextDayName = new Intl.DateTimeFormat("en-GB", {
    weekday: "long",
    timeZone: "Europe/London"
  }).format(deliveryDate);

  const nextDayDate = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    day: "2-digit",
    month: "short"
  }).format(deliveryDate);

  const displayText = `${nextDayName}, ${nextDayDate}`;

  document.querySelectorAll(".js-day").forEach((el) => {
    el.textContent = displayText;
  });
}
updateDeliveryCountdown();
setInterval(updateDeliveryCountdown, 1000);
updateNextDayName();
